import type { Ref } from "react";
import type { ClientListItem } from "../api/types";
import {
  type ManagementAccessHandle,
  ManagementAccessSection,
} from "./management/ManagementAccessSection";

// The access table from the Management tab on the client page, flush inside the
// accordion that holds it (the accordion item has no padding), under a heading.
// The "Manage access" button lives in the accordion header and reaches the
// section through `manageRef`.
export function ClientManagement({
  client,
  manageRef,
}: {
  client: ClientListItem;
  manageRef: Ref<ManagementAccessHandle>;
}) {
  return (
    <>
      <div style={{ padding: 16 }}>
        <h5 className="bf-h5" style={{ margin: 0 }}>
          Management
        </h5>
        <p className="bf-p bfc-base-2" style={{ margin: "4px 0 0" }}>
          Who has access to this client
        </p>
      </div>
      <ManagementAccessSection
        objectId={`client:${client.id}`}
        objectLabel="client"
        grantButton="external"
        manageRef={manageRef}
        embedded
      />
    </>
  );
}
